
import { mixins, Options, Vue } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import * as OM from '@/model';
import WithModel from '@/mixins/withModel';
import moment from 'moment';

@Options({})
export default class weekNavigator extends mixins(WithModel) {

    fromDate: string = "";
    toDate: string = "";

    created(){
        this.localValue = moment(new Date()).startOf('week').toISOString();
        this.fromDate = this.localValue;
        this.toDate = moment(this.localValue).add(1, 'week').toISOString();
        this.emitModel(this.localValue);
    }

    prev(){
        this.localValue = moment(this.localValue).subtract(1, 'week').startOf('week').toISOString();
        this.fromDate = this.localValue;
        this.toDate = moment(this.localValue).add(1, 'week').toISOString();
        this.emitModel(this.localValue);
    }

    next(){
        this.localValue = moment(this.localValue).add(1, 'week').startOf('week').toISOString();
        this.fromDate = this.localValue;
        this.toDate = moment(this.localValue).add(1, 'week').toISOString();
        this.emitModel(this.localValue);
    }

}
